export default {
  english: 'English',
  arabic: 'Arabic',
  login: 'Login',
  cart: 'Cart',
  sidebar: {
    dashboard: 'dashboard',
    products: 'products',
    orders: 'orders',
    offers: 'offers',
    discount: 'discount',
    withdraw: 'withdraw',
    reviews: 'reviews',
    categories: 'categories',
    collection: 'collection',
    processing: 'processing',
    settings: 'settings',
    collections: 'collections',
    support: 'support',
    logout: 'logout'
  }
}
